'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_CONTENT = exports.EDIT_ITEM = exports.ADD_CONTENT = exports.REMOVE_COMMENT = exports.EDIT_COMMENT = exports.ADD_COMMENT = exports.COMMENTS = undefined;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMMENTS = exports.COMMENTS = _constantsAnalytics2.default.CATEGORIES.COMMENTS;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS;
var ADD_COMMENT = _analyticsConstants$E.ADD_COMMENT,
    EDIT_COMMENT = _analyticsConstants$E.EDIT_COMMENT,
    REMOVE_COMMENT = _analyticsConstants$E.REMOVE_COMMENT;
exports.ADD_COMMENT = ADD_COMMENT;
exports.EDIT_COMMENT = EDIT_COMMENT;
exports.REMOVE_COMMENT = REMOVE_COMMENT;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS;
var ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    EDIT_ITEM = _analyticsConstants$A.EDIT_ITEM,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;
exports.ADD_CONTENT = ADD_CONTENT;
exports.EDIT_ITEM = EDIT_ITEM;
exports.REMOVE_CONTENT = REMOVE_CONTENT;


function composeCommentEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: COMMENTS,
    gtmAction: action
  });
}

function composeAddCommentEvent() {
  return (0, _compose.composeAnalytics)([composeCommentEvent(ADD_COMMENT, ADD_CONTENT)]);
}

function composeEditCommentEvent() {
  return (0, _compose.composeAnalytics)([composeCommentEvent(EDIT_COMMENT, EDIT_ITEM)]);
}

function composeRemoveCommentEvent() {
  return (0, _compose.composeAnalytics)([composeCommentEvent(REMOVE_COMMENT, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddCommentEvent: composeAddCommentEvent,
  composeEditCommentEvent: composeEditCommentEvent,
  composeRemoveCommentEvent: composeRemoveCommentEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/commentsEventComposer.js
// module id = 578
// module chunks = 0 2 4 5 6 8 9 10 11